import React from "react";

const Shape = ({ color = "#E1E1E1" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1247.735"
            height="830.801"
            viewBox="0 0 1247.735 830.801"
        >
            <path
                id="Pfad_1796"
                className="svg-shape"
                data-name="Pfad 1796"
                d="M1246.723,394.737l.007-336.26A58.44,58.44,0,0,0,1188.319.009L600.019,0a116.785,116.785,0,0,0-94.887,48.718L11.073,737.224c-27.757,38.682-.137,92.577,47.443,92.577l856.611-.009a116.787,116.787,0,0,0,94.883-48.718l203.8-284.013A175.53,175.53,0,0,0,1246.723,394.737Z"
                transform="translate(1247.23 830.301) rotate(180)"
                fill={color}
                stroke="rgba(0,0,0,0)"
                strokeMiterlimit="10"
                strokeWidth="1"
            />
        </svg>
    );
};

export default Shape;
